import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DecedatiService } from '../decedati.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { Decedat } from '../decedati.interface';

@Component({
    selector: 'app-add-decedati',
    templateUrl: './add-decedati.component.html',
    styleUrls: ['./add-decedati.component.scss']
})
export class AddDecedatiComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        first_name: new FormControl('', [Validators.required]),
        last_name: new FormControl('', [Validators.required]),
        cnp: new FormControl('', [Validators.required]),
        cert_number: new FormControl('', [Validators.required]),
        cert_date: new FormControl('', [Validators.required]),
        obs: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<AddDecedatiComponent>,
        private decedatiService: DecedatiService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const payload: Decedat = {
            first_name: this.form.get('first_name')?.value,
            last_name: this.form.get('last_name')?.value,
            cnp: this.form.get('cnp')?.value,
            cert_number: this.form.get('cert_number')?.value,
            cert_date: this.form.get('cert_date')?.value,
            obs: this.form.get('obs')?.value,
        };

        this.decedatiService
            .storeDecedati(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
